import { BasePageComponent } from '@/components/base/BasePageComponent';
import { DropboxDocTableComponent } from '@/components/dropbox-doc-table/dropbox-doc-table.component';
import { PropertyHelper } from '@/helpers/property.helper';
import { UserHelper } from '@/helpers/user.helper';
import { NavService } from '@/services/nav.service';
import { NotificationCheckService } from '@/services/notification-check.service';
import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ActivatedRoute } from '@angular/router';
import { DropBoxCount, PropertiesService, RealProperty, RealPropertySummary } from '@eemo/api-client';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DataLoadingComponent } from '../../components/data-loading/data-loading.component';
import { DropboxDocTableComponent as DropboxDocTableComponent_1 } from '../../components/dropbox-doc-table/dropbox-doc-table.component';
import { PageTitleComponent } from '../../components/page-title/page-title.component';

@Component({
  selector: 'app-dropbox',
  templateUrl: './dropbox.component.html',
  styleUrls: ['./dropbox.component.scss'],
  standalone: true,
  imports: [PageTitleComponent, NgIf, DataLoadingComponent, MatExpansionModule, NgFor, DropboxDocTableComponent_1]
})
export class DropboxComponent extends BasePageComponent implements OnInit {
  @ViewChildren(DropboxDocTableComponent) dataComponents: QueryList<DropboxDocTableComponent>;

  currentDropBoxCount: DropBoxCount;
  props: RealPropertySummary[] = [];
  data: any;
  expanded: { [key: string]: boolean } = {};
  loading = true;

  constructor(
    private propertiesService: PropertiesService,
    private userHelper: UserHelper,
    public propHelper: PropertyHelper,
    private notificationCheckService: NotificationCheckService,
    public deviceService: DeviceDetectorService,
    protected route: ActivatedRoute,
    protected navService: NavService
  ) {
    super(route, navService);
  }

  ngOnInit() {
    this.notificationCheckService.dropBoxCount.subscribe((count) => {
      if (count) {
        this.currentDropBoxCount = count;
        this.loadData();
        this.reloadComponentsData();
      }
    });
  }

  loadData() {
    this.loading = true;
    this.data = [];
    this.props = [];
    this.expanded = {};
    if (this.currentDropBoxCount) {
      // the property with documents available are first
      this.props = this.currentDropBoxCount.details.map((c) => c.property);
      // extends the panel
      this.props.forEach((p) => (this.expanded[p.uid] = true));
    }
    // get other properties wtih no document
    // TODO manage magination
    this.propertiesService.getRealPropertyList().subscribe({
      next: (propPage) => {
        const otherProps = [];
        propPage.list.forEach((prop: RealProperty) => {
          if (
            prop.certified &&
            this.userHelper.canUpdateProperty(prop) &&
            !this.props.find((p) => p.uid === prop.uid)
          ) {
            otherProps.push(prop as RealPropertySummary);
          }
        });
        otherProps.sort(PropertyHelper.sortPropertiesByName);
        this.props.push(...otherProps);

        // map to data
        this.props.forEach((p) => {
          const row = {
            uid: p.uid,
            prop: p,
            name: p.name,
            dropboxAddress: this.getDropBoxAddressName(p),
            dropboxAddressMailto: this.getDropBoxAddressMailTo(p),
            description: this.getPropDescription(p)
          };
          this.data.push(row);
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  reloadComponentsData() {
    if (this.dataComponents) {
      this.dataComponents.forEach((comp) => comp.loadData());
    }
  }

  getPropDescription(prop: RealProperty) {
    if (this.currentDropBoxCount == null) {
      return 'Aucun document';
    }
    const propCount = this.currentDropBoxCount.details.find((count) => count.property.uid === prop.uid);
    if (!propCount) {
      return 'Aucun document';
    }
    switch (propCount.count) {
      case 0:
        return 'Aucun document';
      case 1:
        return '1 document';
      default:
        return propCount.count + ' documents';
    }
  }

  getDropBoxAddressName(prop: RealProperty) {
    if (this.deviceService.isMobile()) {
      return prop.eemoId;
    }
    return this.propHelper.getDropBoxAddress(prop);
  }

  getDropBoxAddressMailTo(prop: RealProperty) {
    return this.propHelper.getDropBoxAddress(prop);
  }
}
